const THOUSAND = 1_000
const MILLION = THOUSAND * THOUSAND
const BILLION = THOUSAND * MILLION

export { THOUSAND as COUNTER_LIMIT }

const floorOneDecimal = (n: number) => Math.floor(n * 10) / 10

const formatNumber = (num: number) => {
  switch (true) {
    case num < 1_000:
      return `${num}`
    case num < MILLION:
      return `${floorOneDecimal(num / THOUSAND)}K`
    case num < BILLION:
      return `${floorOneDecimal(num / MILLION)}M`
    default:
      return `${floorOneDecimal(num / BILLION)}B`
  }
}

export default formatNumber
